import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import { JWTFetchError, UnloggedError, CredentialsError } from "./AuthErrors.js";
import { buildUrl } from "./utils.js"; // Types
import { AUTH_TYPE } from "./types.js";
/**
 * @deprecated Will not be removed, but we're trying to have a unique login place in account.deezer.com
 * It also provides the jwt as cookie so you can consume it in your projects. This is an implementation
 * detail of account.deezer.com
 * @see https://github.deezerdev.com/Deezer/deezerlib/tree/master/packages/core/auth readme for more information
 */
function WithCredentialsLogin(Base) {
  return class WithCredentialsLoginAuth extends Base {
    loginWithCredentials({
      email,
      password
    }) {
      var _this = this;
      return _asyncToGenerator(function* () {
        const fetchUrl = buildUrl({
          host: _this.host,
          authType: AUTH_TYPE.CREDENTIALS,
          tokenOutputType: _this.tokenOutputType,
          refreshTokenOutputType: _this.refreshTokenOutputType
        });
        const response = yield _this.fetch.call(null, fetchUrl, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            email,
            password
          }),
          credentials: 'include'
        }).catch(() => {
          throw new JWTFetchError('Could not fetch JWT Token with credentials');
        });
        if (!response.ok) {
          if (response.status === 401) {
            throw new CredentialsError('Could not fetch JWT Token with credentials');
          }
          throw new UnloggedError(`Could not fetch JWT Token with credentials. Got error ${response.status}`);
        }
        if (_this.fetchShouldHaveReponse) {
          var _this$refreshTokenCac, _this$tokenCache;
          const {
            jwt,
            refresh_token
          } = yield response.json().catch(() => {
            throw new JWTFetchError('Response does not contain valid tokens');
          });
          (_this$refreshTokenCac = _this.refreshTokenCache) == null || _this$refreshTokenCac.set(refresh_token);
          (_this$tokenCache = _this.tokenCache) == null || _this$tokenCache.set(jwt);
          return jwt;
        }
        return null;
      })();
    }
  };
}
export default WithCredentialsLogin;
//# sourceMappingURL=WithCredentialsLogin.js.map